import { useTranslation } from 'react-i18next';
import { Mark } from './icons';
import { Button } from './ui';

/** Shown while the app checks who is signed in, or when it couldn't (with "Try again"). */
export function Splash({ onRetry, reason = 'offline' }: { onRetry?: () => void; reason?: 'offline' | 'server' }) {
  const { t } = useTranslation();
  return (
    <div className="frame">
      <main className="splash" aria-busy={onRetry ? undefined : true}>
        <Mark size={56} />
        {onRetry ? (
          <>
            <p className="splash__text" role="alert">
              {t(reason === 'server' ? 'errors.server' : 'errors.network')}
            </p>
            <Button inline icon="refresh" onClick={onRetry}>
              {t('app.retry')}
            </Button>
          </>
        ) : (
          <p className="splash__text">{t('app.loading')}</p>
        )}
      </main>
    </div>
  );
}
